<template>
  <div>
    <div class="panel-body no-padding">

      <div class="row">

        <div class="col-md-9">
          <div id="content-commentary" class="chat-discussion border-right">

            <div class="col-md-4 border-right" style="height: 100%;overflow-x: auto">
              <template v-if="authorSelected !== null" >
                <div class="row">
                  <div class="col-xs-6">
                    <label>First Name</label>
                    <div>{{authorSelected.firstName}}</div>
                  </div>

                  <div class="col-xs-6">
                    <label>Last Name</label>
                    <div>{{authorSelected.lastName}}</div>
                  </div>
                </div>

                <div style="margin-top: 10px">
                  <label>Affiliation(s)</label>
                  <div v-for="(affiliation, key) in authorSelected.author_organisations" :key="key">
                    <div class="border-top row" style="padding: 10px 15px">
                      <div class="col-xs-6">
                        <template  v-if="affiliation.organisation">
                          <label>Name</label>
                          <div>{{affiliation.organisation.organisationName}}</div>
                        </template>
                      </div>
                      <div class="col-xs-6">
                        <label>Email</label>
                        <div>{{affiliation.email}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div v-if="authorSelected !== null && authorSelected.commentaries.length !== 0" class="col-md-8">

              <div class="row user-discussion" v-for="(commentary, key) in authorSelected.commentaries" v-bind:key="key" >
                <div class="chat-message right">
                  <div class="message">
                    <span class="message-date">{{commentary.created_at | moment('LLL')}}</span>
                    <span class="message-content">{{commentary.content}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="col-md-8 text-center vertical-mid" style="height: 100%">
              <h5 class="font-bold">No notes yet for this expert</h5>
            </div>

          </div>
        </div>
        <div class="col-md-3">
          <div class="chat-users">
            <div style="padding: 15px">
              <h5 class="text-center font-bold">Experts<span>({{authors.length}})</span></h5>
            </div>
            <div class="users-list">

              <div v-if="authors.length !== 0 && authorSelected !== null" class="">

                <div class="chat-user " :class="authorSelected.authorID === author.id ? 'active' : ''" v-for="(author, key) in authors" v-bind:key="key" v-on:click="setAuthorSelected(author)">

                  <div class="chat-user-name">
                    <a>{{author.firstName}} {{author.lastName}}</a>
                  </div>
                </div>
              </div>
              <div v-else class="col-md-12 text-center vertical-mid " style="height: 380px">
                <h5 class="font-bold">  No Authors for this Question </h5>
              </div>

            </div>

          </div>
        </div>

      </div>
    </div>

    <div class="panel-footer borders" v-if="!$auth.check('basic') && !$auth.check('seeker')">
      <form v-on:submit="sendCommentary">
        <div class="input-group">
          <input type="text" v-model="commentary" class="form-control"   placeholder="Type your note here ... (your note is confidential and won’t be seen by the expert)">
          <div class="input-group-btn">
            <vue-ladda type="submit" :loading="submit.loading" id="btn_send" class="btn btn-info" :data-style="submit.dataStyle">Save note</vue-ladda>
          </div>
        </div>
      </form>
    </div>

  </div>
</template>
<style scoped>
  .chat-user {
    cursor: pointer;
  }

  .chat-user.active {
    background-color: rgba(64, 64, 64, 0.08);
  }
</style>
<script>
import VueLadda from 'vue-ladda'

export default {
  components: {VueLadda},
  props: ['questionId'],
  name: 'Commentary',
  data () {
    return {
      commentary: '',
      authors: [],
      submit: {
        loading: false,
        'dataStyle': ''
      },
      authorSelected: null
    }
  },
  methods: {
    getResources: function () {
      this.axios.get('/question/' + this.questionId + '/authors')
        .then((response) => {
          this.authors = response.data
          this.authorSelected = this.authors[0]
        })
        .catch((error) => {
        })
    },
    setAuthorSelected: function (expert) {
      this.authorSelected = expert
    },
    sendCommentary: function (event) {
      event.preventDefault()
      this.submit.loading = true
      this.errorMessage = null

      this.axios.post('/author/commentary', {
        content: this.commentary,
        external_author_id: this.authorSelected.authorID
      })
        .then((response) => {
          this.submit.loading = false
          this.commentary = null

          this.getResources()
        })
        .catch((error) => {
          this.submit.loading = false
        })
    },
    scrollToEnd: function () {
      let container = this.$el.querySelector('#content-commentary')
      container.scrollTop = container.scrollHeight
    }
  },
  mounted () {
    this.scrollToEnd()
  },
  updated () {
    this.scrollToEnd()
  },
  beforeMount () {
    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/chatSolution/Commentary.vue